import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import LeaveTabsNav from '../../components/Leave/LeaveTabsNav';

export default function LeaveApplicationBalance() {
  const location = useLocation();

  const isAdjustmentPage =
    location.pathname === '/hrm/leave/adjustments';

  return (
    <div className="w-full">

      {/* Header + Tabs */}
      {!isAdjustmentPage && (
        <>
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
              Leave Application & Balance
            </h1>

            <p className="mt-1 text-sm text-gray-500">
              Manage leave requests, allocations, approvals, adjustments, and earnings
            </p>
          </div>

          {/* Tabs Navigation */}
          <div className="mb-6">
            <LeaveTabsNav />
          </div>
        </>
      )}

      {/* Content */}
      {isAdjustmentPage ? (
        <Outlet />
      ) : (
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-clip">
          <div className="p-6">
            <Outlet />
          </div>
        </div>
      )}

    </div>
  );
}